import * as parent from '../variables';
import { IS_ADMIN } from '../../constants/validation';

export const colors = {
  ...parent.colors,

  SELECTED_MENU_BG: '#f0f2f2',
  PRIMARY_BORDER: IS_ADMIN ? '#ccc' : '#f0f2f2',
  MODAL_BACKGROUND: IS_ADMIN ? '#f0f2f2' : '#fff',
  INPUT_BORDER: IS_ADMIN ? '#8A8B8C' : '#ccc',
  PRIMARY_MAIN: '#f0f2f2',
  HEADER_COUNT_TEXT: '#455560',
  PRIMARY_CONTRAST: '#455560',

  GREY: '#999',
  DAILY_LOG_GRAPH_BORDER: '#919191',
  NORMAL_LINK: '#47545e',
  MODAL_TEXT: '#797979',
  MODAL_HEADING: '#575757',
  LIST_TEXT: '#455560',
  HEADER_LIST_TEXT: '#455560',
  LIGHT_BORDER: '#2d2b2b',
  SECONDARY_MAIN: '#bdd731',
  SECONDARY_CONTRAST: '#39434c',
  WHITE: '#fff',
  INPUT_BACKGROUND: '#ffffff',
  RED: '#ff0000',
  BLACK: '#000',
  BACKGROUND: '#fff',
  BLACK_THREE: '#373737',
  RED_TWO: '#d34343',
  GREEN: '#32cd32',
  GREEN_TWO: '#97AE46',
  GREY_ELEVEN: '#777070',
  GREY_TWELVE: '#c3c3c3',
  BLACK_FOUR: '#333333',
  GRAPH_BLACK: '#212121',
  CHART_BLUE: '#00e2ff',
  WARNING: '#ffff00',
  GREY_DATA: '#696969',
  LINK_COLOR: '#bdd731',
  HEADER_COLOR: '#fff',
  DOCUMENT_LINE: '#2C3249',
  DISABLED_COLOR: '#889ccc',
  RADIO_BACKGROUND: '#f0f2f2',
  FORM_COLOR: '#191e22',
  SUGGESTED_COLOR: '#00b7a0',
  BODY_BACKGROUND: '#f0f2f2',
  CHECKBOX_TICK: '#bdd731',
  PAGINATION_BACKGROUND: '#fff',
  PAGINATION_ALTERNATE_BACKGROUND: '#f8f8f8',
  PAGINATION_COLOR: '#fff',
  SELECTED_AREA: 'rgba(32, 177, 232, 0.6)',
  MAP: {
    LIGHT_BLACK: '#424D66',
    LIGHTER_BLACK: '#424D66',
    BLACK: '#424D66',
    GREY: '#d1d1d1',
    LIGHT_GREY: '#d1d1d1',
    LIGHTER_GREY: '#d1d1d1',
    WATER: '#2B364F',
    ROAD: '#37425C',
  },
  LOGIN_BUTTON: '#bdd731',
  BACKGROUND_MENU: '#455560',
  TITLE_COLOR: '#191e22',
  INPUT_COLOR: '#000',

  INPUT_FOCUS: '#bdd731',
  TABLE_ROW_COLOR: '#39434c',
  SORT_ICON: '#bdd731',
  LOGOUT_BUTTON: '#62b4bf',
  PAGINATION_HEADER: '#455560',
  HEADER_TEXT: '#39434c',
  PAGINATION_BORDER: '#f0f2f2',
  RESET_BUTTON: '#47545e',
  ACTION_BORDER: '#455560',
  PRIMARY_BUTTON_TEXT: '#39434c',
  FORM_INPUT_BG: '#f0f2f2',
  MULTISELECT_BACKGROUND: '#455560',
  MULTISELECT_LABEL: '#f0f2f2',
  FORM_BACKGROUND: '#fff',
  RESET_BACKGROUND: '#455560',
  RESET_COLOR: '#ffffff',
  CHECKBOX_BORDER: '#d1d3d6',
  SELECT_ACTIONS: '#444',
  SECONDARY_BORDER: '#d0d4d7',
  TAB_HIGHLIGHT: '#bdd731',
  TAB_BOTTOM_BORDER: '#9cc663',
  TAB_HIGHLIGHT_BACKGROUND: '#fff',
  ACCORDION_BACKGROUND: '#fff',
  USER_LOGO_BACKGROUND: '#455560',
  USER_LOGO_COLOR: '#ffffff',
  POLICIES_BACKGROUND: '#fff',
  RANGE_PICKER: {
    CELL_BG: '#dfdfdf',
    CELL_HOVER_BG: '#bbbbbb',
  },

  ...(IS_ADMIN
    ? {
      ALERT_COLOR: '#ce1e51',
      ALERT_BACKGROUND: '#2a3135',
      CHIP_BG: '#fff',
      TERNARY_BORDER: '#8A8B8C',
      NON_SELCTED_SVG_COLOR: '#000',
      MENU_BORDER_COLOR: '#bdd731',
      MENU_BACKGROUND: '#fff',
      GROUPING_BG_COLOR: '#fff',
      LOGIN_BACKGROUND: '#455560',
    }
    : {}),
};
export default colors;
export const fonts = ['NotoSans-Regular', 'sans-serif'].join(',');
